import { CurrencyMaskConfig } from "ng2-currency-mask";

export const OPTIONS_MASK: CurrencyMaskConfig = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    align: 'right',
    allowNegative: false,
    precision: 2,
    suffix: ''
};

export const OPTIONS_MASK_QTDE: CurrencyMaskConfig = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    align: 'right',
    allowNegative: false,
    precision: 3,
    suffix: ''
};